import type { PantryState } from './welcomeLine'

const SPELL = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']

function editorial(n: number): string {
  return n >= 0 && n < 10 ? SPELL[n] : String(n)
}

function pluralize(n: number, singular: string, plural: string): string {
  return n === 1 ? singular : plural
}

function capitalize(s: string): string {
  return s[0].toUpperCase() + s.slice(1)
}

export type HeroTone = 'urgent' | 'warn' | 'calm' | 'empty'

export type HeroLede = {
  eyebrow:  string
  headline: string
  italic:   string
  tone:     HeroTone
}

export function getHeroLede(state: PantryState): HeroLede {
  const { itemCount, outCount, expiringSoonCount } = state

  if (itemCount === 0) {
    return {
      eyebrow:  'Getting started',
      headline: 'Your pantry is empty.',
      italic:   'pantry',
      tone:     'empty',
    }
  }

  if (outCount > 0 && expiringSoonCount > 0) {
    const low = editorial(outCount)
    const exp = editorial(expiringSoonCount)
    return {
      eyebrow:  'Attention needed',
      headline: `${capitalize(low)} ${pluralize(outCount, 'item is', 'items are')} running low, and ${exp} ${pluralize(expiringSoonCount, 'will', 'will')} expire this week.`,
      italic:   'running low,',
      tone:     'urgent',
    }
  }

  if (outCount > 0) {
    const low = editorial(outCount)
    return {
      eyebrow:  'Running low',
      headline: `${capitalize(low)} ${pluralize(outCount, 'item is', 'items are')} running low.`,
      italic:   'running low.',
      tone:     'urgent',
    }
  }

  if (expiringSoonCount > 0) {
    const exp = editorial(expiringSoonCount)
    return {
      eyebrow:  'Expiring soon',
      headline: `${capitalize(exp)} ${pluralize(expiringSoonCount, 'item', 'items')} will expire this week.`,
      italic:   'expire',
      tone:     'warn',
    }
  }

  return {
    eyebrow:  'All good',
    headline: 'Your pantry is well-stocked.',
    italic:   'well-stocked.',
    tone:     'calm',
  }
}
